import tingle from 'tingle.js'
import { formatPrice } from '../common/formatters'
import { on } from 'delegated-events'
import tippy from 'tippy.js/esm'

const SELECTORS = Selectors({
  addToCartForm: 'product-add-to-cart-form',
  addToCartSubmit: 'product-add-to-cart-form [type=submit]',
  continueShopping: 'continue-shopping',
  multipleToc: 'store-product__toc--multiple',
  multipleTocContent: 'store-product__toc-content',
  multipleDownload: 'store-product__download--multiple',
  multipleDownloadContent: 'store-product__download-content',
  qtyField: 'select[name=Qty]',
  perUserField: 'select[name=PerUserQty]',
  typeField: 'select[name=Type]',
  priceField: 'price-field',
  siteNavCart: 'site-nav__cart',
  formErrorMessage: 'form-error-message',
  loading: 'is-loading'
})

const props = {
  $addToCartForm: document.querySelector(SELECTORS.asClass('addToCartForm')),
  $addToCartSubmit: document.querySelector(SELECTORS.asClass('addToCartSubmit')),
  $multipleToc: document.querySelector(SELECTORS.asClass('multipleToc')),
  $multipleTocContent: document.querySelector(SELECTORS.asClass('multipleTocContent')),
  $multipleDownload: document.querySelector(SELECTORS.asClass('multipleDownload')),
  $multipleDownloadContent: document.querySelector(SELECTORS.asClass('multipleDownloadContent')),
  $qtyField: document.querySelector(SELECTORS.qtyField),
  $perUserField: document.querySelector(SELECTORS.perUserField),
  $typeField: document.querySelector(SELECTORS.typeField),
  $priceField: document.querySelector(SELECTORS.asClass('priceField')),
  $siteNavCart: document.querySelector(SELECTORS.asClass('siteNavCart')),
  priceData: []
}

const fn = {
  init: () => {
    fn.bindEvents()

    if (props.$multipleToc) {
      fn.setupMultipleToc()
    }

    if (props.$multipleDownload) {
      fn.setupMultipleDownload()
    }

    if (props.$addToCartForm) {
      props.priceData = JSON.parse(document.getElementById('product-price-data').textContent)
      fn.handleTypeChange()
    }
  },

  bindEvents: () => {
    if (props.$addToCartForm) {
      props.$typeField.addEventListener('change', fn.handleTypeChange)
      props.$addToCartForm.addEventListener('submit', fn.handleAddToCart)
    }
  },

  handleTypeChange: () => {
    const value = props.$typeField.value

    if (value) {
      const price = props.priceData.find(o => o.key === value).price

      props.$priceField.classList.add('price-field--active')
      props.$priceField.querySelector('span').textContent = formatPrice(price)

      if (props.$addToCartSubmit) {
        props.$addToCartSubmit.disabled = false
      }
    } else {
      props.$priceField.classList.remove('price-field--active')
      props.$priceField.querySelector('span').textContent = '0'
      props.$addToCartSubmit.disabled = true
    }
  },

  setupMultipleToc: () => {
    const tocTip = tippy(props.$multipleToc, {
      theme: 'light',
      trigger: 'click',
      arrow: true,
      interactive: true,
      placement: 'bottom',
      content: props.$multipleTocContent.innerHTML
    })

    // Close the tooltip when clicking a link
    on('click', '.store-product__toc-list a', () => {
      tocTip.hide(0)
    })
  },

  setupMultipleDownload: () => {
    const downloadTip = tippy(props.$multipleDownload, {
      theme: 'light',
      trigger: 'click',
      arrow: true,
      interactive: true,
      placement: 'bottom',
      content: props.$multipleDownloadContent.innerHTML
    })

    // Close the tooltip when opening the modal
    on('click', '[data-modal]', () => downloadTip.hide(0))
    on('click', '.store-product__download-list a', () => downloadTip.hide(0))
  },

  handleAddToCart: (e) => {
    e.preventDefault()

    const $form = props.$addToCartForm

    const $errorMessage = $form.querySelector(SELECTORS.asClass('formErrorMessage'))
    $errorMessage.style.display = 'none'

    const $submitButton = props.$addToCartSubmit
    $submitButton.disabled = true
    $submitButton.classList.add(SELECTORS.loading)

    ajax.post($form.action, new FormData($form))
      .then((resp) => {
        if (resp.data.success) {
          const modal = new tingle.modal({
            closeMethods: ['button', 'escape', 'overlay'],
            cssClass: ['modal--content'],
            beforeOpen: () => {
              modal.modal.classList.add('modal--loading')

              // Move the close button
              const $closeBtn = modal.modal.querySelector('.tingle-modal__close')
              modal.modal.querySelector('.tingle-modal-box').appendChild($closeBtn)
            },
            onOpen: () => {
              modal.modal.classList.remove('modal--loading')
            },
            onClose: () => {
              modal.destroy()
              fn.handleContinueShopping()
            }
          })

          modal.setContent(resp.data.html)
          modal.open();

          on('click', SELECTORS.asClass('continueShopping'), () => modal.close())

          // Update the site nav cart count
          const $currentCartCount = props.$siteNavCart.querySelector('span')
          props.$siteNavCart.classList.remove('site-nav__cart--empty')
          $currentCartCount.textContent = resp.data.cart_count
        } else {
          $errorMessage.innerHTML = resp.data.message
          $errorMessage.style.display = 'block'
        }
      })
      .catch(() => {
        $errorMessage.innerHTML = 'Sorry, there was a problem with your submission'
        $errorMessage.style.display = 'block'
      })
      .finally(() => {
        $submitButton.disabled = false
        $submitButton.classList.remove(SELECTORS.loading)
      })
  },

  handleContinueShopping: () => {
    props.$qtyField.value = 1

    if (props.$typeField.options.length > 2) {
      props.$typeField.value = null
    }

    fn.handleTypeChange()
  }
}

export default {
  can: () => document.querySelector('.store-product-page'),
  run: fn.init
}
